import { PROGRAMS_ASSETS } from 'shared/lib/utils';
import { getAmpConfig } from 'shared/config/amp-config';
import { Asset } from 'shared/api/retail';

import {
  AquaUserLicensesResponse,
  RelevantAquaUserLicensesArgs,
} from './types';
import {
  BOOST_LECTURA_PROGRAM_ID,
  BOOST_READING_PROGRAM_ID,
  LICENSE_TYPES,
} from './constants';

const getBoostAssetObj = () => ({
  businessKey: PROGRAMS_ASSETS.BoostReadingAqua,
  name: 'Boost Reading Aqua',
  type: 'other',
  metadata: {
    product: 'Boost Reading',
    dashboard: {
      appUrl: '',
      display: false,
      thumbnailUrl: '',
      thumbnailLargeUrl: '',
    },
  },
});

const getBoostLecturaAssetObj = () => ({
  businessKey: PROGRAMS_ASSETS.BoostLectura,
  name: 'Boost Lectura Aqua',
  type: 'application',
  metadata: {
    product: 'Boost Lectura',
    dashboard: {
      appUrl: '',
      display: false,
      thumbnailUrl: '',
      thumbnailLargeUrl: '',
    },
  },
});

export const normalizeAquaUserLicensesResponse = ({
  Licenses,
}: AquaUserLicensesResponse): Asset[] => {
  const readingLicense = Licenses['Reading'];
  const hasReadingLicense =
    readingLicense && LICENSE_TYPES.includes(readingLicense.LicenseType);

  const lecturaLicense = Licenses['Lectura'];
  const hasLecturaLicense =
    lecturaLicense && LICENSE_TYPES.includes(lecturaLicense.LicenseType);

  const boostAssets = [];

  if (hasLecturaLicense) {
    boostAssets.push(getBoostLecturaAssetObj());
    boostAssets.push({
      businessKey: BOOST_LECTURA_PROGRAM_ID,
      name: 'Boost Reading / Lectura',
      type: 'application',
      metadata: {
        dashboard: {
          appUrl: getAmpConfig().amplifyReading,
          display: true,
          thumbnailUrl:
            'https://s3.amazonaws.com/amplify-retail-public-dev/assets/reading/aqua-large-thumb.png',
          thumbnailLargeUrl:
            'https://s3.amazonaws.com/amplify-retail-public-dev/assets/reading/aqua-large-thumb.png',
        },
        nav: {
          display: true,
          section: 'Programs',
          openInNewTab: false,
        },
      },
    });
  }

  if (hasReadingLicense) {
    boostAssets.push(getBoostAssetObj());
    boostAssets.push({
      businessKey: BOOST_READING_PROGRAM_ID,
      name: 'Boost Reading',
      type: 'application',
      metadata: {
        dashboard: {
          appUrl: getAmpConfig().amplifyReading,
          display: true,
          thumbnailUrl:
            'https://s3.amazonaws.com/amplify-retail-public-dev/assets/reading/aqua-large-thumb.png',
          thumbnailLargeUrl:
            'https://s3.amazonaws.com/amplify-retail-public-dev/assets/reading/aqua-large-thumb.png',
        },
        nav: {
          display: true,
          section: 'Programs',
          openInNewTab: false,
        },
      },
    });
  }

  return boostAssets;
};

export const filterAquaUserLicenses = ({
  aquaUserLicenses,
  hasBoostReadingAssetInRetail,
  hasBoostLecturaAssetInRetail,
}: RelevantAquaUserLicensesArgs): Asset[] => {
  if (!aquaUserLicenses) return [];

  if (hasBoostReadingAssetInRetail && hasBoostLecturaAssetInRetail) return [];

  if (hasBoostReadingAssetInRetail) {
    return aquaUserLicenses.filter((aquaAsset) => {
      return aquaAsset.businessKey === PROGRAMS_ASSETS.BoostLectura;
    });
  }

  if (hasBoostLecturaAssetInRetail) {
    return aquaUserLicenses.filter((aquaAsset) => {
      return aquaAsset.businessKey === PROGRAMS_ASSETS.BoostReadingAqua;
    });
  }

  return aquaUserLicenses;
};
